import { Form, Modal } from "antd";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import { TypeCommon } from "models/common";
import BaseInput from "components/base-input";
import { schemaValidate } from "validation/change-password";
import { converSchemaToAntdRule } from "validation";

const ModalChangePassword = ({
  form,
  open,
  handleCancel,
  handleConfirm,
  forceOpen = false,
}: {
  form: TypeCommon;
  open: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  forceOpen?: boolean;
}): ReactElement => {
  const { t } = useTranslation();
  const yupSync = converSchemaToAntdRule(schemaValidate);
  return (
    <Modal
      title={t("header.change-password")}
      centered
      forceRender
      maskClosable={false}
      closable={!forceOpen}
      open={open}
      onCancel={forceOpen ? undefined : handleCancel}
      onOk={(): void => form.submit()}
      cancelButtonProps={forceOpen ? { style: { display: "none" } } : undefined}
      okText={t("button.confirm")}
      className="modal-confirm-email modal-custom"
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleConfirm}
        autoComplete="off"
        className="w-full"
      >
        {/* <BaseInput
          name="oldPassword"
          label={"現在のパスワード"}
          height={50}
          type="password"
          required={false}
          rule={[yupSync]}
          className="w-full"
        /> */}
        <BaseInput
          name="newPassword"
          label={t("reset-password.new-password")}
          type="password"
          required={false}
          rule={[yupSync]}
          height={50}
          onKeyDown={(e: TypeCommon): void => {
            if (e.key === "Enter") {
              form.submit();
            }
          }}
        />
        <BaseInput
          name="passwordConfirm"
          label={t("reset-password.password-confirm")}
          type="password"
          required={false}
          rule={[
            yupSync,
            ({ getFieldValue }: TypeCommon): TypeCommon => ({
              // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
              validator() {
                if (
                  getFieldValue("passwordConfirm") &&
                  getFieldValue("passwordConfirm") !==
                    getFieldValue("newPassword")
                ) {
                  return Promise.reject(
                    new Error(t("login.password-not-match")),
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
          height={50}
          onKeyDown={(e: TypeCommon): void => {
            if (e.key === "Enter") {
              form.submit();
            }
          }}
        />
      </Form>
    </Modal>
  );
};

export default ModalChangePassword;
